(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // TOT: open the desktop mega menu on HOVER (interior pages only).
  // (Kept in this single javascript block — a section may only have one.)
  // Interior pages get the `.header--inline-search` header. There, open each
  // top-level mega menu on hover instead of click. We drive the existing
  // <header-menu> (HeaderMenu/DetailsDisclosure) by toggling the <details>
  // [open] attribute, so its native toggle event still fires (animations,
  // aria, sticky-header preventHide all keep working). Desktop only — below
  // 990px the inline menu is hidden and the hamburger drawer is used.
  (function () {
    var CLOSE_DELAY = 150;

    function isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function initHoverMegaMenus() {
      var header = document.querySelector('.header--inline-search');
      if (!header) return; // landing page (no inline-search header)

      var menus = header.querySelectorAll('.header__inline-menu header-menu');

      menus.forEach(function (menu) {
        if (menu.dataset.hoverBound) return; // guard against double-binding
        menu.dataset.hoverBound = '1';

        var details = menu.querySelector('details');
        if (!details) return;
        var summary = details.querySelector('summary');
        var closeTimer;

        function openMenu() {
          clearTimeout(closeTimer);
          // close any other open mega menu so only one shows at a time
          menus.forEach(function (other) {
            if (other === menu) return;
            var d = other.querySelector('details');
            if (d && d.open) {
              if (typeof other.close === 'function') other.close();
              else d.removeAttribute('open');
            }
          });
          if (!details.open) {
            details.setAttribute('open', '');
            if (summary) summary.setAttribute('aria-expanded', 'true');
          }
        }

        function closeMenu() {
          if (typeof menu.close === 'function') menu.close();
          else {
            details.removeAttribute('open');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }
        }

        menu.addEventListener('mouseenter', function () {
          if (!isDesktop()) return;
          openMenu();
        });

        menu.addEventListener('mouseleave', function () {
          if (!isDesktop()) return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
        });

        // On desktop, hover controls open/close — suppress the native click
        // toggle (which would close a hovered-open menu). e.detail === 0 means
        // keyboard activation, which we leave intact for accessibility.
        if (summary) {
          summary.addEventListener('click', function (e) {
            if (isDesktop() && e.detail !== 0) e.preventDefault();
          });
        }
      });
    }

    if (document.readyState !== 'loading') initHoverMegaMenus();
    else document.addEventListener('DOMContentLoaded', initHoverMegaMenus);
  })();

  } catch(e) { console.error(e); }
})();
})();
